export enum LayoutBackroundColor {
  white = 'white',
  dark = 'dark',
  yellow = 'yellow',
  purple = 'purple',
  green = 'green',
  blue = 'blue',
  gray = 'gray',
}
